import { Box, Button, CircularProgress, Paper, Stack, styled, Typography } from '@mui/material';
import SuccessImg from 'assets/success_img.png';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SubmissionService from 'services/SubmissionService';

export interface ErrorResponseType {
  message: string;
  error_code: string;
  errors?: ErrorType[];
}

export interface ErrorType {
  path: string;
  message: string;
}

const ReconfirmationSuccessPage = () => {
  const { submissionId } = useParams();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const signature = searchParams.get('signature') || '';
  const email = searchParams.get('email') || '';
  const nonce = searchParams.get('nonce') || '';

  useEffect(() => {
    (async () => {
      if (submissionId) {
        setIsLoading(true);
        SubmissionService.reconfirmationSuccess(submissionId, { email, signature, nonce })
          .catch((error) => {
            if (error.response?.data.error_code === 'SUBMISSION_REVIEW_COMPLETED') {
              return setIsError(false);
            }

            if (error.response?.data.error_code === 'SUBMISSION_UPDATE_NOT_ALLOWED') {
              return setIsError(false);
            }

            return setIsError(true);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    })();
  }, [email, nonce, signature, submissionId]);

  const goToBSS = () => {
    // navigate to BSS Website
    window.location.href = 'https://www.banksampoerna.com';
  };

  const onPageReload = () => {
    // reload page
    window.location.reload();
  };

  return (
    <PaperStyled>
      {isLoading ? (
        <BoxLoadingSpinner>
          <CircularProgress />
          <Typography color="surface.700" fontWeight="500" variant="h7">
            Mohon menunggu, permintaan sedang di proses...
          </Typography>
        </BoxLoadingSpinner>
      ) : isError ? (
        <BoxLoadingSpinner>
          <Typography color="surface.700" fontWeight="500" variant="h7">
            Sistem mengalami kendala, mohon coba kembali beberapa saat lagi
          </Typography>
          <Button variant="contained" sx={{ maxWidth: 200 }} onClick={onPageReload}>
            Coba Kembali
          </Button>
        </BoxLoadingSpinner>
      ) : (
        <StackStyled spacing={2}>
          <img alt="success-img" src={SuccessImg} height="160" width="160" />
          <Typography color="surface.700" variant="h4">
            Aplikasi Dikonfirmasi
          </Typography>
          <Typography color="surface.700" align="center" maxWidth="604px">
            Terimakasih telah mengkonfirmasi aplikasi pembukaan rekening Giro BSS.
          </Typography>
          <Button variant="contained" sx={{ maxWidth: 200 }} onClick={goToBSS}>
            Kembali ke Beranda
          </Button>
        </StackStyled>
      )}
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3)
}));

const StackStyled = styled(Stack)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const BoxLoadingSpinner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 300,
  gap: theme.spacing(5)
}));

export default ReconfirmationSuccessPage;
